'use strict';

exports.__esModule = true;
exports.updateRepeaterItems = updateRepeaterItems;
exports.syncRepeaterItemData = syncRepeaterItemData;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _modelUtils = require('../../modelUtils');

var modelUtils = _interopRequireWildcard(_modelUtils);

var _repeaterUtils = require('../../repeaterUtils/repeaterUtils');

var _repeaterUtils2 = _interopRequireDefault(_repeaterUtils);

var _cloneComponent = require('../../cloneComponent');

var _cloneComponent2 = _interopRequireDefault(_cloneComponent);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cloneConnections(model, templateCompIds, itemIds) {
  var connections = _lodash2.default.get(model, 'connections');
  var contexts = _lodash2.default.keys(connections);
  _lodash2.default.forEach(contexts, function (context) {

    var roles = _lodash2.default.keys(_lodash2.default.get(connections, context));
    _lodash2.default.forEach(roles, function (role) {

      var compIds = _lodash2.default.keys(_lodash2.default.get(connections, [context, role]));
      _lodash2.default.forEach(compIds, function (compId) {
        if (_lodash2.default.includes(templateCompIds, compId)) {
          var templateConfig = _lodash2.default.get(connections, [context, role, compId]);

          _lodash2.default.forEach(itemIds, function (itemId) {
            var displayedItemId = _repeaterUtils2.default.structure.getUniqueDisplayedId(compId, itemId);
            _lodash2.default.set(connections, [context, role, displayedItemId], _lodash2.default.cloneDeep(templateConfig));
          });
        }
      });
    });
  });
}

function updateCompsScope(model, templateCompIds, itemIds) {
  _lodash2.default.forEach(templateCompIds, function (templateCompId) {
    _lodash2.default.forEach(itemIds, function (itemId) {
      var displayedItemId = _repeaterUtils2.default.structure.getUniqueDisplayedId(templateCompId, itemId);
      model.componentsScopes[displayedItemId] = null;
    });
  });
}

function cloneComponents(model, templateCompIds, itemIds, repeaterId) {
  _lodash2.default.forEach(templateCompIds, function (templateCompId) {
    _lodash2.default.forEach(itemIds, function (itemId) {
      var newDisplayedCompId = _repeaterUtils2.default.structure.getUniqueDisplayedId(templateCompId, itemId);
      var templateData = model.components[templateCompId];
      var newDisplayedCompData = (0, _cloneComponent2.default)(templateData);
      newDisplayedCompData.displayedOnlyComponents = [];
      newDisplayedCompData.children = _lodash2.default.map(templateData.children, function (childId) {
        return _repeaterUtils2.default.structure.getUniqueDisplayedId(childId, itemId);
      });
      newDisplayedCompData.parent = templateData.parent === repeaterId ? repeaterId : _repeaterUtils2.default.structure.getUniqueDisplayedId(templateData.parent, itemId);
      newDisplayedCompData.displayedRoot = repeaterId;
      newDisplayedCompData.isDisplayed = !!_lodash2.default.get(model.components[repeaterId], 'isDisplayed');
      /*change data-item id for refs*/
      _lodash2.default.forEach(_repeaterUtils2.default.structure.SPLITTED_DATA_TYPES, function (dataType) {
        var compDataTypeValue = newDisplayedCompData[dataType];
        if (compDataTypeValue.id) {
          compDataTypeValue.id = _repeaterUtils2.default.structure.getUniqueDisplayedId(newDisplayedCompData[dataType].id, itemId);
          _lodash2.default.forEach(compDataTypeValue, function (val, key) {
            if (_lodash2.default.isObject(val) && val.id) {
              compDataTypeValue[key].id = _repeaterUtils2.default.structure.getUniqueDisplayedId(compDataTypeValue[key].id, itemId);
            }
          });
        }
      });

      model.components[newDisplayedCompId] = newDisplayedCompData;
    });
  });
}

function cloneComponentsAndConnections(model, templateCompIds, itemIds, repeaterId) {
  cloneConnections(model, templateCompIds, itemIds);
  cloneComponents(model, templateCompIds, itemIds, repeaterId);
  updateCompsScope(model, templateCompIds, itemIds);
}

function removeConnections(model, templateCompIds, itemIds) {
  var connections = _lodash2.default.get(model, 'connections');
  var contexts = _lodash2.default.keys(connections);

  _lodash2.default.forEach(contexts, function (context) {
    var roles = _lodash2.default.keys(_lodash2.default.get(connections, [context]));

    _lodash2.default.forEach(roles, function (role) {
      var compIds = _lodash2.default.keys(_lodash2.default.get(connections, [context, role]));

      _lodash2.default.forEach(compIds, function (compId) {
        var compItemId = _repeaterUtils2.default.structure.getItemId(compId);
        var compOriginalId = _repeaterUtils2.default.structure.getOriginalId(compId);

        if (compItemId && _lodash2.default.includes(itemIds, compItemId) && _lodash2.default.includes(templateCompIds, compOriginalId)) {
          delete connections[context][role][compId];
        }
      });
    });
  });
}

function removeCompsScope(model, templateCompIds, itemIds) {
  _lodash2.default.forEach(templateCompIds, function (templateCompId) {
    _lodash2.default.forEach(itemIds, function (itemId) {
      var displayedItemId = _repeaterUtils2.default.structure.getUniqueDisplayedId(templateCompId, itemId);
      delete model.componentsScopes[displayedItemId];
    });
  });
}

function removeComponents(model, templateCompIds, itemIds) {
  _lodash2.default.forEach(templateCompIds, function (templateCompId) {
    _lodash2.default.forEach(itemIds, function (itemId) {
      var displayedItemId = _repeaterUtils2.default.structure.getUniqueDisplayedId(templateCompId, itemId);
      delete model.components[displayedItemId];
    });
  });
}

function removeComponentsAndConnections(model, templateCompIds, itemIds) {
  removeConnections(model, templateCompIds, itemIds);
  removeCompsScope(model, templateCompIds, itemIds);
  removeComponents(model, templateCompIds, itemIds);
}

/*on repeater set items - creates displayed components and connections for added items and removes components and connections that are no loger in items*/
function updateRepeaterItems(RMI, hookName, repeaterId, partial) {
  if (partial.items) {
    var templateCompIds = modelUtils.getAllCompsUnderRoot(RMI._model, repeaterId);
    var repeaterData = _lodash2.default.get(RMI._model.components, [repeaterId, 'data']);
    var addedItems = _repeaterUtils2.default.items.getAddedItems(repeaterData.items, partial.items);
    cloneComponentsAndConnections(RMI._model, templateCompIds, _lodash2.default.map(addedItems, 'item._id'), repeaterId);

    var removedItems = _repeaterUtils2.default.items.getRemovedItems(repeaterData.items, partial.items);
    removeComponentsAndConnections(RMI._model, templateCompIds, _lodash2.default.map(removedItems, 'item._id'));
    _lodash2.default.forEach(templateCompIds, function (templateCompId) {
      var templateCompData = RMI._model.components[templateCompId];
      templateCompData.displayedOnlyComponents = _lodash2.default.map(partial.items, function (itemId) {
        return _repeaterUtils2.default.structure.getUniqueDisplayedId(templateCompId, itemId);
      });
    });
  }
}

/*Hook triggered on each set and check if the set is for template sync all existing item instances*/
function syncRepeaterItemData(RMI, hookName, compId) {
  var _arguments = arguments;

  var model = RMI._model;
  // set comp property to the template comp, since its isDisplayed property is always false
  if (hookName !== 'registerEvent' && modelUtils.isTemplateComp(model, compId)) {
    var comp = _lodash2.default.get(model, ['components', compId]);
    var partial = arguments[3];
    model.components[compId][hookName] = _lodash2.default.defaults({}, partial, comp[hookName]);
  }

  var displayedOnlyComponents = _lodash2.default.get(RMI._model.components, [compId, 'displayedOnlyComponents']);
  if (!_lodash2.default.isEmpty(displayedOnlyComponents)) {
    //is repeater template with displayed only comps
    var funcName = 'set' + _lodash2.default.startCase(hookName);
    if (hookName === 'registerEvent') {
      funcName = 'registerEvent';
      _lodash2.default.forEach(displayedOnlyComponents, function (itemId) {
        var args = [].concat(Array.prototype.slice.call(_arguments));
        RMI[funcName].apply(RMI, [args[3], itemId].concat(args.splice(4)));
      });
      return;
    }
    _lodash2.default.forEach(displayedOnlyComponents, function (itemId) {
      var args = [].concat(Array.prototype.slice.call(_arguments));
      if (hookName === 'data' && !_lodash2.default.isFunction(_lodash2.default.last(args))) {
        //if there is no callback should call setDataWithoutUpdate and not setData
        RMI.setDataWithoutUpdate.apply(RMI, [itemId].concat(args.splice(3)));
        return;
      }
      var rmiActionArgs = [itemId].concat(args.splice(3));
      if (_lodash2.default.isFunction(_lodash2.default.last(rmiActionArgs))) {
        rmiActionArgs.pop();
      }
      RMI[funcName].apply(RMI, rmiActionArgs);
    });
  }
}
//# sourceMappingURL=repeaterHooks.js.map